import { render, staticRenderFns } from "./discoveryProcess.vue?vue&type=template&id=bcc34e66&scoped=true&"
import script from "./discoveryProcess.vue?vue&type=script&lang=js&"
export * from "./discoveryProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc34e66",
  null
  
)

export default component.exports